export default "__VITE_ASSET__CZrCYoL5__"